import { Chip, IconButtonButton } from "@evergis/ui";
import styled from "styled-components";

export const EditResourceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem 0;
  width: 100%;
`;

export const EditResourceWrapper = styled.div`
  display: flex;
  gap: 0 1.5rem;
  width: 100%;
`;

export const EditResourcePreview = styled.div`
  width: 10rem;
  height: 7.5rem;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
`;

export const EditResourceMeta = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 1px;
  gap: 1rem 0;
`;

export const TagsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 0.5rem 0.25rem;
`;

export const TagChip = styled(Chip)`
  padding: 4px 6px;
  border-radius: 0.25rem;
  height: 20px;
  gap: 0 0.25rem;
  box-sizing: border-box;

  ${IconButtonButton} {
    width: 1rem;
    height: 1rem;
  }
`;

export const TagName = styled.div`
  font-size: 10px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.icon};
`;
